import constants from '../../../../common/constants';

const form_name = 'withdrawalForm';

const fields = {
  amount: 'amount',
  description: 'description',
  payment_method_id: 'payment_method_id',
  currency: 'currency',
};

const min_withdrawal_amount = constants.is_prod_env ? 250 : 1;

const withdrawal_currencies = {
  usd: {
    value: 'USD',
    text: 'USD',
    symbol: '$',
  },
  eur: {
    value: 'EUR',
    text: 'EUR',
    symbol: '€',
  },
};

const bensUserIdProd = 293292;

export default {
  form_name,
  fields,
  min_withdrawal_amount,
  withdrawal_currencies,
  bensUserIdProd,
};



// WEBPACK FOOTER //
// ./src/app/main/withdrawals/constants/withdrawal-constants.js